const printButtons = document.querySelectorAll(".js--print-button");

const printPage = () => {
  window.print();
}

if (printButtons) {
  [].forEach.call(printButtons, button => {
    button.addEventListener("click", e => {
      e.preventDefault();
      printPage();
    })
  })
}